import { useLocation, useNavigate } from "react-router-dom";

export const useNavigateWithKey = () => {
  const navigate = useNavigate();

  const navigateWithKey = (path, state = {}) => {
    const uniqueKey = `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;
    navigate(path, {
      state: { ...state, locationKey: uniqueKey },
    });
  };

  return navigateWithKey;
};


export const useNavigateWithSameKey = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithSameKey = (path, state = {}) => {
    const uniqueKey = location.state?.locationKey;

    navigate(path, {
      state: { ...state, locationKey: uniqueKey },
    });
  };

  return navigateWithSameKey; 
}
